import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import 'xe-utils'
import VxeTable from 'vxe-table'
import 'vxe-table/lib/style.css'

import './assets/iconfont/iconfont.css'
// ShUI组件
import Conponents from './components/index'

Vue.use(ElementUI)

Vue.use(VxeTable)

// 防抖节流工具函数
import deTh from './utils/deTh'

// 支持组件包直接导出使用工具函数
export * from './utils/index'
export * from './components/index'
export default {
  version: '1.1.0',
  ...Conponents,
  ...deTh
}
